import React from 'react';
import { useBreakpoint, useHover } from '@landr/maestro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import { SuggestionsType } from 'components/Filters/context/SearchBarContext/types';
import { ModifiersPayload } from 'controllers/SearchController/types';
import useDeleteUserRecentSearch from 'apollo/userRecentSearch/useDeleteUserRecentSearch';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import useSuggestionItem from '../hooks/useSuggestionItem';
import SuggestionGeneric from './SuggestionGeneric';

const SuggestionItem = ({
    modifiers,
    suggestionType,
    isSelected,
}: {
    modifiers?: ModifiersPayload;
    suggestionType: SuggestionsType;
    isSelected: boolean;
}) => {
    const [hoverRef, isHovered] = useHover(false);
    const isModal = useBreakpoint('md');
    const { applySuggestion } = useSearchBarContext();

    const { isAuthenticated } = useAuthentication();

    const deleteUserRecentSearch = useDeleteUserRecentSearch({
        isAuthenticated,
    });

    const {
        filterName,
        filterCategories,
        handleClick,
        icon,
        handleRemoveRecentSuggestion,
        isRemoveSuggestionVisible,
    } = useSuggestionItem({
        modifiers,
        applySuggestion,
        deleteUserRecentSearch,
        suggestionType,
        isHovered,
    });

    if (!filterName) {
        return null;
    }

    return (
        <SuggestionGeneric
            hoverRef={hoverRef}
            filterCategories={filterCategories}
            filterName={filterName}
            handleClick={handleClick}
            handleRemoveRecentSuggestion={handleRemoveRecentSuggestion}
            isRemoveSuggestionVisible={isRemoveSuggestionVisible}
            icon={icon}
            isModal={isModal}
            isSelected={isSelected}
        />
    );
};

export default SuggestionItem;
